import {
  ESimulatorAMS275912PorosityClass,
} from '@/types/simulator.ts';

const details: Record<ESimulatorAMS275912PorosityClass, string> = {
  [ESimulatorAMS275912PorosityClass.CLASS_1]: 'nie więcej niż 15%',
  [ESimulatorAMS275912PorosityClass.CLASS_2]: '10% - 40%',
};

export default {
  details,
};
